
<template>
  <div>
    <data-list :payload="listPayloadObj" :headers="headers" v-model="pagination" :total="total" :pagination="pagination"></data-list>
    <v-dialog v-model="dialog" width="600" persistent>
      <form-template :references.sync="formReferences" :model="modelObj" ref="fieldsReference"></form-template>
      <v-card>
        <v-progress-linear indeterminate v-if="fieldLoading"></v-progress-linear>
        <template v-if="showFields">
          <template>
            <v-card-text>
              <p><i><u>{{ $t('message.common.note') }}</u></i> : <i>{{ $t('message.template.placeholderUsageMessage') }}</i></p>
              <b>{{ $t('message.template.sharepointFields') }}</b>
              <v-row>
                <v-col cols="6" v-for="(field, index) in templateFields.sharepointfields" :key="index">{{ field.title }}: <strong>{{ field.name }}</strong></v-col>
              </v-row>
            </v-card-text>
            <v-divider></v-divider>
          </template>
          <v-card-text>
            <b>{{ $t('message.template.moduleFields') }}</b>
            <v-row>
              <v-col cols="6" v-for="(field, index) in templateFields.modulefields" :key="index">{{ field.title }}: <strong>{{ field.name }}</strong></v-col>
            </v-row>
          </v-card-text>
        </template>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import DataList from '@/components/DataList.vue'
import FormTemplate from '@/components/FormTemplate'
import documentTemplateMixin from './templateMixin'
export default {
  mixins: [documentTemplateMixin],
  data () {
    return {
      total: 0,
      dialog: false,
      modelObj: {},
      listPayloadObj: {
        isHeader: true,
        isHideAdd: true,
        selection: [],
        showSelect: true,
        headers: [],
        list: [],
        loading: false,
        editProp: 'name',
        addClickHandler: this.openDialogHandler,
        editHandler: this.getSingleRecordHandler,
        actionsList: [{
          click: (item) => this.navigation(item.sharepoint_link),
          icon: (item) => 'mdi-open-in-new',
          is_show: (item) => true,
          color: (item) => 'primary'
        }]
      },
      loading: false,
      pagination: !this.$formatter.isEmptyObject(this.$store.state.TEMPLATE_INDEX) ? this.$store.state.TEMPLATE_INDEX : { sortBy: ['name'], itemsPerPage: 25, sortDesc: [false], search: '' },
      MODULE: 'documenttemplates',
      templateFields: {},
      fieldLoading: false,
      showFields: false
    }
  },
  components: {
    DataList,
    FormTemplate
  },
  computed: {
    headers () {
      return [{
        text: this.$t('message.props.name'),
        value: 'name',
        isRoute: true,
        isModal: true,
        width: '50%'
      }, {
        text: this.$t('message.document.module'),
        value: 'module',
        width: '40%'
      }, {
        text: '',
        value: 'actions',
        width: '10%'
      }]
    },
    ...mapGetters(['formType']),
    formReferences () {
      return {
        title: this.modelObj.id ? this.$t('message.template.update') : this.$t('message.template.add'),
        properties: [{
          model: 'name',
          type: this.formType.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.props.name'),
          class: 'xs12'
        }, {
          model: 'module',
          type: this.formType.SELECT,
          rules: [],
          items: this.documentTemplateModules,
          select_text: 'text',
          select_value: 'value',
          label: this.$t('message.document.module'),
          class: 'xs12'
        }, {
          model: 'files',
          rules: [],
          type: this.formType.FILES,
          accept: 'application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          class: 'xs12',
          label: this.$t('message.props.template'),
          is_show: !this.modelObj.id
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.modelObj.id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: this.saveUpdateHandler,
          loading: this.loading,
          is_show: true
        }, {
          name: 'close',
          color: 'error',
          click: this.closeDialogHandler,
          label: this.$t('message.common.close'),
          is_show: true
        }]
      }
    }
  },
  watch: {
    pagination: {
      handler (val) {
        const model = { type: 'TEMPLATE_INDEX', data: val }
        this.$store.commit('rememberOrder', model)
        this.getListHandler()
      },
      deep: true
    },
    'modelObj.module' (val) {
      this.showFields = false
      if (val) this.getTemplateVariables(val)
    }
  },
  mounted () {
    const text = this.$t('message.common.deleteMsg')
    this.$eventBus.$on('deleteItems', (data) => {
      if (data.module === this.MODULE) {
        const payload = { ids: data.ids, url: `${this.MODULE}/delete_multiple`, module: this.MODULE }
        this.$store.commit('showDeleteDialog', payload)
      }
    })
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.MODULE) {
        this.listPayloadObj.selection = []
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getListHandler()
      }
    })
  },
  methods: {
    getTemplateVariables (module) {
      this.fieldLoading = true
      this.$_executeApi('get', `documenttemplates/get_template_variables?module=${module}`).then((response) => {
        this.templateFields = response.data
        this.showFields = true
      }).finally(() => {
        this.fieldLoading = false
      })
    },
    getListHandler () {
      this.listPayloadObj.loading = true
      this.listPayloadObj.module = this.MODULE
      const queryFields = this.$formatter.cloneVariable(this.headers)
      queryFields.splice(queryFields.length - 1, 1)
      const { page, search, sortBy, sortDesc, itemsPerPage } = this.$formatter.cloneVariable(this.pagination)
      const pageVal = page || 1
      const query = {
        order_by: {
          field: sortBy.join(''),
          asc_or_desc: sortDesc[0] ? 'desc' : 'asc'
        },
        skip: ((pageVal - 1) * itemsPerPage),
        limit: itemsPerPage,
        include_count: true,
        filter: `${queryFields.map(x => x.value).join(` contains '${search || ''}' OR `)} contains '${search || ''}'`
      }
      this.$_executeApi('post', `${this.MODULE}/query`, query)
        .then((response) => {
          const { values, count } = response.data
          this.listPayloadObj.loading = false
          values.map(x => {
            const result = this.documentTemplateModules.find(y => y.value === x.module)
            x.module = result ? result.text : ''
            return x
          })
          this.listPayloadObj.list = values
          this.total = count
        })
    },
    getSingleRecordHandler (id) {
      this.$_getSingleRecordHandler(`${this.MODULE}/${id}`).then((result) => {
        if (result.data) this.modelObj = result.data
        this.dialog = true
      })
    },
    openDialogHandler () {
      this.dialog = true
    },
    closeDialogHandler () {
      this.dialog = false
      this.modelObj.id = undefined
      this.$refs.fieldsReference.$refs.validateForm.reset()
    },
    saveUpdateHandler () {
      if (this.$refs.fieldsReference.$refs.validateForm.validate()) {
        this.loading = true
        const model = this.modelObj
        const url = this.MODULE
        if (!model.id) {
          const formData = new FormData()
          formData.append('name', model.name)
          formData.append('module_id', model.module || 0)
          const file = model.files
          formData.append(file.name, file)
          this.$_saveUpdateHandler(url, formData).then((response) => {
            this.closeDialogHandler()
            this.getListHandler()
          }).finally(() => {
            this.loading = false
          })
        } else {
          this.$_saveUpdateHandler(url, model).then((response) => {
            this.closeDialogHandler()
            this.getListHandler()
          }).finally(() => {
            this.loading = false
          })
        }
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    navigation (link) {
      window.open(link)
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('deleteItems')
  }
}
</script>
